interface Props {
  /** 0-100. */
  value: number;
  label?: string;
  /** Renders thinner, for use inside a list row. */
  compact?: boolean;
}

export default function ProgressBar({ value, label, compact }: Props) {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className={`progress${compact ? ' progress--compact' : ''}`}>
      <div
        className="progress-track"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ?? 'Progress'}
      >
        <div className="progress-fill" style={{ width: `${clamped}%` }} />
      </div>
      {label && <span className="progress-label">{label}</span>}
    </div>
  );
}
